import { agencyActionTypes } from "./currentAgencyActionTypes";

const INITIAL_STATE = {
  currentAgency: null,
};

const agencyReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case agencyActionTypes.STORE_AGENCY_DETAILS:
      return {
        ...state,
        currentAgency: action.payload,
      };

    default:
      return state;
  }
};

export default agencyReducer;
